import 'intersection-observer';

export const waitUntilExist = (things: any, time: number, callback: () => void) => {
    if(typeof things !== 'undefined' || things !== null) {
        callback();
    }
    else {
        setTimeout(function() {
            waitUntilExist(things, time, callback);
        }, time);
    }
};

export const createScriptTag = (content: string | null, url?: string, callback?: () => void): void  => {
    const script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    if (content !== null) {
        script.appendChild(document.createTextNode(content));
    }

    if (typeof url !== 'undefined') {
        script.setAttribute('defer', 'defer');
        script.setAttribute('src', url);
    }

    if (typeof callback !== 'undefined') {
        script.onload = callback;
    }

    document.body.appendChild(script);
};

export interface IPageObserverEntry {
    element: HTMLElement;
    callback: (entry: IntersectionObserverEntry) => void;
    threshold?: number[];
}

export const createObserver = (args: IPageObserverEntry[]): void => {
    args.forEach((entry, index: number) => {
        const observer = new IntersectionObserver((entries, observer) => {
            if (typeof args[index] !== 'undefined') {
                args[index].callback(entries[0]);
            }
        }, {
            threshold: typeof entry.threshold !== 'undefined' ? entry.threshold : [0.5, 0.75]
        });
        observer.observe(entry.element);
    });
};

export const initObserver = (args: (IPageObserverEntry | null)[]): void => {
    const observableElements: IPageObserverEntry[] = [];

    args.forEach((observable: IPageObserverEntry | null) => {
       if (observable !== null) {
           observableElements.push(observable)
       }
    });

    if (observableElements.length > 0) {
        createObserver(observableElements);
    }
};
